{
  "labels": {
    "aircraft": "Flugzeug",
    "limitToCompleted": "Nur Abgeschlossene",
    "limitToNotCompleted": "Nur nicht abgeschlossene",
    "locked": "Gesperrt?",
    "isHidden": "Ausgeblendet?"
  },
  "buttons": {
    "new": "Neu",
    "deploy": "Deployen"
  },
  "snackbar": {
    "staging": "Zur Info – Du bist auf Staging",
    "editingCompleted": "Du bearbeitest ein abgeschlossenes Flugzeug.",
    "deploymentStarted": "Flugzeugdaten-Bereitstellung gestartet. Fortschritt unter Super Admin > Systemstatus verfolgen.",
    "deploymentFailed": "Deployment fehlgeschlagen"
  },
  "confirmations": {
    "lockToggle": "Bist du dir sicher?",
    "hiddenToggle": "Sicher, Großer?",
    "deployTitle": "Deploy bestätigen",
    "deployText": "Möchtest du wirklich bereitstellen?",
    "deployOk": "Los geht's!"
  },
  "errors": {
    "deployFailed": "Flugzeugdaten-Bereitstellung fehlgeschlagen"
  },
  "presenter": {
    "labels": {
      "topView": "Draufsicht",
      "sideView": "Seitenansicht"
    },
    "buttons": {
      "removeImage": "Bild entfernen"
    }
  },
  "inputForm": {
    "labels": {
      "id": "ID",
      "make": "Neu",
      "model": "Modell",
      "linkAircraftTo": "Dieses Flugzeug verknüpfen mit",
      "wingBottom": "Flügelunterseite",
      "wingTop": "Flügelspitze",
      "horizontalTailBottom": "Horizontales Leitwerk unten —",
      "horizontalTailTop": "Höhenleitwerk oben —",
      "verticalTailBottom": "Seitenleitwerk unten |",
      "verticalTailTop": "Seitenleitwerk oben |",
      "cabinBottom": "Kabinenboden",
      "cabinTop": "Kabinendecke",
      "nose": "Nase",
      "midline": "Mittellin.",
      "length": "Länge",
      "wingspan": "Spannweite",
      "tailHeight": "Heckhöhe",
      "contourNumber": "Kontur Nr.",
      "simplifyPercent": "Vereinfachen %",
      "bottom": "Unten",
      "top": "Oben",
      "limitDegrees": "Grad begrenzen",
      "front": "Vorne",
      "rear": "Heck",
      "tailWheel": "Spornrad?",
      "fuelCapacity": "Tankkapazität",
      "fuelType": "Kraftstoffart",
      "cruiseBurn": "Reiseflug-Verbrauch (gal/h)",
      "cruiseSpeed": "Reisegeschwindigkeit (kts)",
      "reserves": "Reserven (gal)",
      "cruiseAltitude": "Reiseflughöhe (ft)",
      "isHelicopter": "Ist Hubschrauber?"
    },
    "buttons": {
      "remove": "Entfernen",
      "save": "Speichern",
      "noPropeller": "kein Propeller",
      "select": "Auswählen",
      "clear": "Löschen",
      "auto": "auto"
    },
    "sections": {
      "referencePoints": "Referenzpunkte",
      "orientation": "Ausrichtung",
      "propellers": "Propeller",
      "dimensions": "Abmessungen",
      "outline": "Gliederung",
      "overlaps": "Konflikte",
      "wings": "Flügel",
      "horizontalTail": "Höhenleitwerk",
      "verticalTailFin": "Seitenleitwerk",
      "cabin": "Kabine",
      "towing": "Schleppen",
      "fuel": "Fuel",
      "helicopter": "Hubschrauber"
    },
    "fuelTypes": {
      "jetA": "Jet A",
      "avGas": "AvGas",
      "other": "Andere"
    },
    "helperText": {
      "cruiseBurn": "Typischer Kraftstoffverbrauch im Reiseflug in Gallonen pro Stunde",
      "cruiseSpeed": "Typische Reisegeschwindigkeit (TAS) in Knoten",
      "reserves": "Typische Treibstoffreserven (VFR/IFR-Alternate + Sicherheit)",
      "cruiseAltitude": "Typische Reiseflughöhe in Fuß (z. B. 41000 für FL410)"
    }
  }
}
